module.exports = __webpack_public_path__ + "img/liucheng2.622143a9.jpg";